import { Button, makeStyles, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { scheduleAnInterview } from '../../api/candidate';
import { useDebounce, useNotification } from '../../hooks';
import Modal from '../common/modal';
import InterviewForm from '../forms/interview';

const useStyles = makeStyles({
  root: {
    width: '55.3125rem',
    ['@media (max-width:420px)']: {
      padding:24,
    },
  },
  title: {
    fontSize: '2.5rem',
    lineHeight: '2.9375rem',
    marginBottom: '.8125rem',
    ['@media (max-width:420px)']: {
      fontSize: '1.5rem',
      lineHeight: '1.9375rem',
      fontWeight: '700',
    },
  },
  body: {
    fontSize: '1.25rem',
    lineHeight: '150%',
    marginBottom: '2.0625rem',
    ['@media (max-width:420px)']: {
      fontSize: '1rem',
      lineHeight: '120%',
      marginBottom: '1.0625rem',
    },
  },
  button: {
    marginTop: '2.875rem',
    ['@media (max-width:420px)']: {
      marginTop: '1.875rem',
    },
  },
});

const Interview = () => {
  const { hash } = useParams();
  const classes = useStyles();
  const notifications = useNotification();
  const [disabled, setDisabled] = useState(false);
  const [open, setOpen] = useState(false);

  const handleSubmit = useDebounce((data) => {
    setDisabled(true);
    scheduleAnInterview(hash, data)
      .ready()
      .then((res) => {
        if (res.success) {
          notifications.success({
            message: 'Thanks for your request, our team will contact you soon',
          });
          setOpen(false);
        } else
          notifications.error({
            message:
              'Your request could not be processed at this time, please retry later.\nThanks and sorry for the inconvenience.',
          });
      })
      .finally(() => {
        setDisabled(false);
      });
  }, 1000);

  return (
    <>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Schedule an interview
      </Button>
      <Modal
        className={classes.root}
        open={open}
        disableBackdropClick={false}
        onClose={() => setOpen(false)}
      >
        <Typography className={classes.title} variant="h2" align="center">
          Schedule an Interview
        </Typography>
        <Typography className={classes.body} variant="body1" align="center">
          Great! Let's schedule an interview for you. Please let us know some
          days or times that work for you and we will reach out to you to
          coordinate an interview time.
        </Typography>
        <InterviewForm disabled={disabled} onSubmit={handleSubmit} />
      </Modal>
    </>
  );
};

export default Interview;
